<div
  class="city-selector-wrapper flex justify-between flex-row relative city-pair-gap"
>
  <jb-form-field-container
    class="flex flex-grow-1 flex-column items-stretch city-pair-min-width"
    [ngClass]="{
      'jb-invalid': showValidationErrors && !!formGroup.controls.origin.errors
    }"
  >
    <dot-city-selector
      [formControl]="formGroup.controls.origin"
      [type]="CitySelectorType.ORIGIN"
      [content]="content"
      [showShortCityName]="showShortCityName"
      [suggestions]="origins"
      [recentAirports]="recentAirports?.originRecentAirports || []"
      [filterOutPartner]="false"
      [hideLegend]="hideLegend"
      [customLegendMessage]="customLegendMessage"
      [separatePartnerCities]="separatePartnerCities"
      [formWrapper]="formWrapper"
      [enableFuzzySearch]="content.enableFuzzySearch"
      (airportChange)="originChange.emit($event)"
      (userChangedAirport)="userChangedOrigin.emit($event)"
      data-qaid="fromAirport"
    >
    </dot-city-selector>
    <ng-container *ngIf="showValidationErrors">
      <jb-error
        *ngFor="let error of formGroup.controls.origin.errors | keyvalue"
        [forError]="error.key"
        [showErrorIf]="true"
        aria-live="polite"
        data-qaid="fromAirport-autocomplete-polite-error"
      >
        <div>
          <span aria-hidden="true">{{ error.value }}</span>
          <jb-sr-only>Error: {{ error.value }}</jb-sr-only>
        </div>
      </jb-error>
    </ng-container>
  </jb-form-field-container>

  <!-- swap arrows -->
  <button
    *ngIf="swappable"
    type="button"
    (click)="swap()"
    class="t-fast absolute cb z-2 b--medium-gray bg-white icon-swap flex items-center justify-center ba br-100 pointer"
  >
    <span class="clip">{{ content.swapLabel }}</span>
    <jb-icon
      class="rt-icon flex items-center flex-column w-100 fill-royal-blue"
      [@swapIcon]="swapClicked"
      name="arrowRoundtrip"
      width="0.8em"
      height="0.9em"
    ></jb-icon>
  </button>

  <jb-form-field-container
    class="flex flex-grow-1 flex-column items-stretch city-pair-min-width"
    [ngClass]="{
      'jb-invalid':
        showValidationErrors && !!formGroup.controls.destination.errors
    }"
  >
    <dot-city-selector
      [formControl]="formGroup.controls.destination"
      [type]="CitySelectorType.DESTINATION"
      [content]="content"
      [showShortCityName]="showShortCityName"
      [suggestions]="destinations"
      [recentAirports]="recentAirports?.destinationRecentAirports || []"
      [filterOutPartner]="false"
      [hideLegend]="hideLegend"
      [customLegendMessage]="customLegendMessage"
      [separatePartnerCities]="separatePartnerCities"
      [formWrapper]="formWrapper"
      [enableFuzzySearch]="content.enableFuzzySearch"
      (airportChange)="destinationChange.emit($event)"
      (userChangedAirport)="userChangedDestination.emit($event)"
      data-qaid="toAirport"
    >
    </dot-city-selector>
    <ng-container *ngIf="showValidationErrors">
      <jb-error
        *ngFor="let error of formGroup.controls.destination.errors | keyvalue"
        [forError]="error.key"
        [showErrorIf]="true"
        aria-live="polite"
        data-qaid="toAirport-autocomplete-polite-error"
      >
        <div>
          <span aria-hidden="true">{{ error.value }}</span>
          <jb-sr-only>Error: {{ error.value }}</jb-sr-only>
        </div>
      </jb-error>
    </ng-container>
  </jb-form-field-container>
</div>
